import keyMirror from '@kopapro-redux/utils/key-mirror';

// misc action type
export default keyMirror({
  TRIGGER_DEMO_ACTION: null,
  SHOW_DEMO_MESSAGE: null,
  HIDR_DEMO_MESSAGE: null,
});
